export enum UserType {
  bot = "bot",
  broadcast = "broadcast",
  intercom = "intercom",
  bizStaff = "biz_staff",
  bizGuest = "biz_guest",
  bizAgency = "biz_agency",
  none = "",
}
